import { createReducer } from '../lib/createReducer';

const initialState = {
  summary: null,
  summaryError: null,
  daily: { items: [], meta: null },
  dailyError: null,
  workflows: { items: [], totalCount: 0, meta: null },
  workflowsError: null,
  workflowSeries: { series: [], meta: null },
  workflowSearch: { items: [], meta: null },
  installations: { strip: null, items: [], meta: null },
  installationsError: null,
  // Keyed by installationId so revisiting a detail after viewing another one
  // still hits the cache.
  installationDetailById: {},
  installationDetailError: null
};

export default createReducer(initialState, {
  // Org switches don't reload the app (useChangeCompany.js), so every cached
  // window here belongs to the previous company — purge and let the state
  // handler refetch.
  SET_SESSION_COMPANY_ID: () => initialState,
  GET_USAGE_SUMMARY_SUCCESS: (state, payload) => ({
    ...state,
    summary: payload?.data || null,
    summaryError: null
  }),
  GET_USAGE_SUMMARY_FAIL: (state, payload) => ({
    ...state,
    summaryError: payload?.message || 'Failed to load the usage summary.'
  }),
  GET_USAGE_DAILY_SUCCESS: (state, payload) => ({
    ...state,
    daily: { items: payload?.data?.items || [], meta: payload?.meta || null },
    dailyError: null
  }),
  GET_USAGE_DAILY_FAIL: (state, payload) => ({
    ...state,
    dailyError: payload?.message || 'Failed to load daily usage.'
  }),
  GET_USAGE_WORKFLOWS_SUCCESS: (state, payload) => ({
    ...state,
    workflows: {
      items: payload?.data?.items || [],
      totalCount: payload?.data?.totalCount || 0,
      meta: payload?.meta || null
    },
    workflowsError: null
  }),
  GET_USAGE_WORKFLOWS_FAIL: (state, payload) => ({
    ...state,
    workflowsError: payload?.message || 'Failed to load workflow usage.'
  }),
  GET_USAGE_WORKFLOW_SERIES_SUCCESS: (state, payload) => ({
    ...state,
    workflowSeries: { series: payload?.data?.series || [], meta: payload?.meta || null }
  }),
  GET_USAGE_WORKFLOW_SEARCH_SUCCESS: (state, payload) => ({
    ...state,
    workflowSearch: { items: payload?.data?.items || [], meta: payload?.meta || null }
  }),
  GET_USAGE_INSTALLATIONS_SUCCESS: (state, payload) => ({
    ...state,
    installations: {
      strip: payload?.data?.strip || null,
      items: payload?.data?.items || [],
      meta: payload?.meta || null
    },
    installationsError: null
  }),
  GET_USAGE_INSTALLATIONS_FAIL: (state, payload) => ({
    ...state,
    installationsError: payload?.message || 'Failed to load installation usage.'
  }),
  GET_USAGE_INSTALLATION_DETAIL_SUCCESS: (state, payload) => ({
    ...state,
    installationDetailById: {
      ...state.installationDetailById,
      [payload?.meta?.installationId]: { ...(payload?.data || {}), meta: payload?.meta || null }
    },
    installationDetailError: null
  }),
  GET_USAGE_INSTALLATION_DETAIL_FAIL: (state, payload) => ({
    ...state,
    installationDetailError: payload?.message || 'Failed to load installation detail.'
  })
});
